import { Component, ViewChild, inject } from '@angular/core';
import {
	ItButtonDirective,
	ItIconComponent,
	ItModalComponent,
} from 'design-angular-kit';
import { IterlexService } from '../iterlex.service';
import { TranslateModule } from '@ngx-translate/core';
import type { Error } from '../interfaces/error';

@Component({
	selector: 'app-error-dialog',
	imports: [
		ItButtonDirective,
		ItIconComponent,
		ItModalComponent,
		TranslateModule,
	],
	templateUrl: './error-dialog.component.html',
	styleUrl: './error-dialog.component.scss',
})
export class ErrorDialogComponent {
	private iterlexService = inject(IterlexService);

	@ViewChild(ItModalComponent) errorModal!: ItModalComponent;
	error: Error = {};
	constructor() {
		this.iterlexService.error$.subscribe((error) => {
			this.error = error;
			this.errorModal.toggle();
		});
	}
	ignoreConstraints() {
		this.iterlexService
			.ignoreStepConstraints(
				this.error.additionalData!['authority'],
				this.error.additionalData!['body'],
				this.error.additionalData!['expressionUri'],
				this.error.additionalData!['phaseName'],
				this.error.additionalData!['stepId'],
			)
			.subscribe(() => {
				this.iterlexService
					.setVersionStep(
						this.error.additionalData!['authority'],
						this.error.additionalData!['body'],
						this.error.additionalData!['expressionUri'],
						this.error.additionalData!['phaseName'],
						this.error.additionalData!['stepId'],
					)
					.subscribe();
			});
	}
}
